function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 2a2.917 2.917 0 00-2.917 2.917c0 1.302 1.907 3.676 2.637 4.537a.365.365 0 00.56 0c.73-.861 2.637-3.235 2.637-4.537A2.917 2.917 0 008 2zm0 3.889a.972.972 0 110-1.944.972.972 0 010 1.944zm-6.2 1.11a.74.74 0 00-.467.688v5.794a.37.37 0 00.508.344l3.196-1.455V6.975A7.01 7.01 0 014.545 5.9L1.8 7zM8 10.326c-.326 0-.634-.143-.845-.393a24.451 24.451 0 01-1.377-1.776v4.213l4.444 1.482V8.157a24.437 24.437 0 01-1.377 1.776c-.211.25-.52.393-.845.393zm6.159-4.595l-3.196 1.454v6.667l3.238-1.295a.74.74 0 00.466-.688V6.075a.37.37 0 00-.508-.344z",
  fill: "#333",
  fillRule: "evenodd"
});

function SvgAtomIconActionListinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgAtomIconActionListinline;